<div (click)="goUrl()" class="thumb-container" *ngIf="isLivingCancerAvailable">
  <div class="img-container">
    <img [src]="livingWithImage" alt="">
  </div>
  <div class="thumb-title">
    <p class="nomargin">{{'Living With' | translate}}</p>
    <p class="nomargin">{{'Cancer' | translate }}</p>
  </div>
</div>
